import api from '../api-methods'

const proxyHost = process.env.VUE_APP_ENV === 'local' ? '/proxy_host' : process.env.VUE_APP_LINK
const proxyApi = process.env.VUE_APP_ENV === 'local' ? '/proxy_api' : process.env.VUE_APP_API
const proxyHr = process.env.VUE_APP_ENV === 'local' ? '/proxy_hr' : process.env.VUE_APP_API_HR
const proxyLive = process.env.VUE_APP_ENV === 'local' ? '/proxy_live' : process.env.VUE_APP_LIVE

const live = {

  // 直播相关 api
  /*
    @ 获取 RTC token
    * channel_name  频道名
    * uid           用户accountToken
  */
  getRtcToken: data => {
    return api.post(`${proxyLive}/v1/agora_generate_rtc_token`, data )
  },
  /*
    @ 获取 直播信息
    * live_token 直播token
  */
  getLiveDetail: live_token => {
    return api.get(`${proxyApi}/v3/lives/${live_token}`)
  },
  /*
    @ 获取直播直播相关职位
    * live_token 直播token
  */
  getLiveDetailJobs: (live_token, params={}) => {
    return api.get(`${proxyHr}/v2/live/${live_token}/job`, params )
  },

  /*
    @ 获取直播相关精品评论
    * live_token 直播token
  */
  getLiveDetailComments: live_token => {
    return api.get(`${proxyApi}/v3/lives/${live_token}/comments`, {} )
  },

  /*
    @ 获取直播相关精品评论详情
    * comment_id 评论id
  */
  getLiveDetailCommentDetail: (comment_id) => {
    return api.get(`${proxyApi}/v3/lives/comments/${comment_id}`, {} )
  },
  /*
    @ 公司、职位、校招直播列表
    * live_type // company comp_recruit job
    * token // company comp_recruit job 的 token
  */
  getLiveAppointList: params => {
    return api.get(`${proxyApi}/v3/lives/appoint`, params )
  },
  /*
    @ 查看用户是否预约直播
    * live_token 直播token
  */
  getLiveAppoint: (data={}) => {
    return api.post(`${proxyApi}/v3/lives/appoint`, data )
  },
  /*
    @ 预约直播
    * live_tokens 直播token
  */
  liveAddAppoint: (live_token) => {
    return api.post(`${proxyApi}/v3/lives/${live_token}/appoint`, {} )
  },
  /*
    @ 取消预约直播
    * live_token 直播token
  */
  liveDeleteAppoint: (live_token) => {
    return api.delete(`${proxyApi}/v3/lives/${live_token}/appoint`, {} )
  },

  /*
    @ 点赞直播
    * live_token 直播token
  */
  liveLikeDetail: (live_token) => {
    return api.put(`${proxyApi}/v3/lives/${live_token}`, {} )
  },

  /*
    @ 查看用户直播投递职位
    * live_token 直播token
  */
  getLiveDelivryList: (live_token) => {
    return api.get(`${proxyApi}/v3/lives/${live_token}/delivry`)
  },

  // 更新直播点赞
  liveLikeCount: (live_token, data) => {
    return api.post(`${proxyHr}/v2/live/${live_token}/like`, data )
  },

  // 更新直播观看人数
  liveWatchCount: (live_token) => {
    return api.post(`${proxyHr}/v2/live/${live_token}/view`, {} )
  },

  // 获取直播列表
  getLiveList: () => {
    return api.get(`${proxyApi}/v3/lives`)
  },

  // 获取直播回放
  getLivePlayback: (live_token) => {
    return api.get(`${proxyHr}/v2/live/${live_token}/cloud_recording`, {} )
  }

}

export default live
